import { Promise } from "es6-promise";

export interface IIntraActive {
  Authentication: IAuthentication;
}

export interface IAuthentication {
  AuthorizationPromise?: Promise<void>;
}

declare global {
  interface Window {
    IntraActive: IIntraActive
  }
}

window.IntraActive = window.IntraActive || { Authentication: {} };
window.IntraActive.Authentication = window.IntraActive.Authentication || {};


// WEBPACK FOOTER //
// ./src/Global/index.ts